export default {
    changeContent({commit}, statusName) {
        commit('SET_CONTENT', statusName)
    },
    changeCompanyIds({ commit }, statusName) {
        console.log(statusName,'1212');
        commit('SET_COMPANYTD', statusName)
    },
}


// WEBPACK FOOTER //
// ./src/vuex/actions.js